import { Link } from 'react-router-dom';
import { useState, type FormEvent } from 'react';
import { Icon } from '@iconify/react';
import { Brand } from './Brand';
import { api } from '../lib/api';
import { useSite } from '../lib/site-context';

export function Footer() {
  const { site } = useSite();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function subscribe(event: FormEvent) {
    event.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await api.newsletter(email);
      setMessage('E-mail cadastrado com sucesso.');
      setEmail('');
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'Não foi possível concluir agora.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        {/* Bloco Institucional e Redes Sociais */}
        <div>
          <Brand footer />
          <p className="footer-copy">
            {site.settings['site.description'] ||
              'Desenvolvimento web, redes, servidores, DNS, segurança e soluções digitais.'}
          </p>

          <div className="social-links" aria-label="Redes sociais">
            {site.settings['social.linkedin'] ? (
              <a href={site.settings['social.linkedin']} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Icon icon="simple-icons:linkedin" width="14" height="14" />
              </a>
            ) : (
              <span aria-hidden="true">
                <Icon icon="simple-icons:linkedin" width="14" height="14" />
              </span>
            )}

            {site.settings['social.instagram'] ? (
              <a href={site.settings['social.instagram']} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Icon icon="simple-icons:instagram" width="14" height="14" />
              </a>
            ) : (
              <span aria-hidden="true">
                <Icon icon="simple-icons:instagram" width="14" height="14" />
              </span>
            )}

            {site.settings['social.whatsapp'] ? (
              <a href={site.settings['social.whatsapp']} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <Icon icon="simple-icons:whatsapp" width="14" height="14" />
              </a>
            ) : (
              <span aria-hidden="true">
                <Icon icon="simple-icons:whatsapp" width="14" height="14" />
              </span>
            )}

            {site.settings['social.github'] ? (
              <a href={site.settings['social.github']} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <Icon icon="simple-icons:github" width="14" height="14" />
              </a>
            ) : (
              <span aria-hidden="true">
                <Icon icon="simple-icons:github" width="14" height="14" />
              </span>
            )}

            {site.settings['social.facebook'] ? (
              <a href={site.settings['social.facebook']} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Icon icon="simple-icons:facebook" width="14" height="14" />
              </a>
            ) : (
              <span aria-hidden="true">
                <Icon icon="simple-icons:facebook" width="14" height="14" />
              </span>
            )}
          </div>
        </div>

        {/* Links Institucionais */}
        <div className="footer-column">
          <h2>Links</h2>
          <Link to="/servicos">Soluções</Link>
          <Link to="/portfolio">Portfólio</Link>
          <Link to="/sobre">Sobre</Link>
          <Link to="/parceiros">Parceiros</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/contato">Contato</Link>
        </div>

        {/* Serviços e Soluções */}
        <div className="footer-column">
          <h2>Serviços</h2>
          <Link to="/web">Desenvolvimento Web</Link>
          <Link to="/redes">Redes & Provedores</Link>
          <Link to="/servidores">Servidores & Cloud</Link>
          <Link to="/dns-dominios">DNS & Domínios</Link>
          <Link to="/seguranca">Segurança</Link>
        </div>

        {/* Newsletter */}
        <div className="footer-column">
          <h2>Novidades</h2>
          <p>Receba atualizações sobre tecnologia e soluções da A3GS Tec.</p>

          <form className="newsletter" onSubmit={subscribe}>
            <label className="sr-only" htmlFor="newsletter-email">
              Seu e-mail
            </label>
            <input
              name="newsletter-email"
              id="newsletter-email"
              type="email"
              required
              disabled={loading}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu e-mail"
            />
            <button aria-label="Cadastrar e-mail" disabled={loading}>
              <Icon
                icon={loading ? 'lucide:loader-2' : 'lucide:send'}
                width="16"
                height="16"
                className={loading ? 'dash-spin' : ''}
              />
            </button>
          </form>

          <small aria-live="polite" style={{ display: 'block', marginTop: '8px' }}>
            {message}
          </small>
        </div>
      </div>

      {/* Rodapé Inferior com Links para Termos e Privacidade */}
      <div className="footer-bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} A3GS Tec. Todos os direitos reservados.</span>
          <span>
            <Link to="/privacidade">Privacidade</Link> · <Link to="/termos">Termos</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}